import { CommunicationTemplatePlatform } from './communications';

export enum FutureCommunicationTaskStatus {
  Pending = 'pending',
  Sent = 'sent',
  Failed = 'failed',
}

export interface FutureCommunicationTask {
  id: string;
  accountId: string;
  executeAt: Date;
  status: FutureCommunicationTaskStatus;
  platform: CommunicationTemplatePlatform;
  fallbackPlatform: CommunicationTemplatePlatform;
  content: {
    sms: {
      text: string;
      templateName: string;
      subscriptionGroup: string;
    } | null;
    email: {
      from: string;
      params: {
        name: string;
        gfName: string;
        content: string;
      };
      templateId: string;
      templateName: string;
    } | null;
    push: {
      notification: {
        title: string;
        body: string;
      };
      pushData?: {
        navTo: string;
        avatar: string;
        navParams: {
          accountId: string;
          isPrivate: boolean;
          groupInstanceId: string;
        };
      };
      subscriptionGroup?: string;
      templateId?: string;
    } | null;
  };
  privateChat?: {
    groupInstanceId: string;
    senderId: string;
    message: string;
  };
  dateCreated: Date;
}
